/** BizCharts G2 tooltip item template; `{color}` is supplied by the chart at runtime. */
export const ANALYTICS_CHART_TOOLTIP_ITEM_TPL = `
                    <li data-index={index}>
                        <span class="analytics-breakdown-tooltip-marker" style="background-color:{color};"></span>
                        {name}: {value}
                    </li>
        `;
